import { getRandomIntInclusive } from '@application/utils';
import { CardItem, SkeletonBox } from '@presentation/components';
import type { FC } from 'react';
import { useMemo } from 'react';
import type { CardItemProSmallProps } from './types';

export * from './types';

export const CardItemProSmall: FC<CardItemProSmallProps> = (props) => {
  const { image, title, subtitle, onClick, loading = false, ...rest } = props;

  const skeletons = useMemo(() => {
    return {
      title: { width: getRandomIntInclusive(100, 200), height: 21.7 },
      subtitle: { width: getRandomIntInclusive(100, 200), height: 21.7 },
    };
  }, []);

  if (loading)
    return (
      <CardItem
        loading
        content={{
          title: <SkeletonBox style={{ ...skeletons.title }} />,
          subtitle: <SkeletonBox style={{ ...skeletons.subtitle }} />,
        }}
      />
    );

  return (
    <CardItem
      image={image}
      content={{
        title,
        subtitle,
      }}
      onClick={onClick}
      {...rest}
    />
  );
};
